import React from 'react';
import { Section } from './ui/Section';
import { FileText, Search, CheckSquare, ThumbsUp } from 'lucide-react';
export function LoanProcess() {
  const steps = [{
    icon: FileText,
    title: 'Application',
    desc: 'Submit your loan application form.'
  }, {
    icon: Search,
    title: 'Review',
    desc: 'We review your documents.'
  }, {
    icon: CheckSquare,
    title: 'Assessment',
    desc: 'Credit & risk assessment.'
  }, {
    icon: ThumbsUp,
    title: 'Approval',
    desc: 'Loan approved & disbursed.'
  }];
  return <Section id="process" bg="offwhite" data-id="element-359">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-360">
        <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-361">
          How It Works
        </h2>
        <h3 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-362">
          Our Loan Process
        </h3>
        <p className="text-gray-600" data-id="element-363">
          We guide you through every stage with clarity and professionalism.
        </p>
      </div>

      <div className="relative" data-id="element-364">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0" data-id="element-365" />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10" data-id="element-366">
          {steps.map((step, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-367">
              <div className="w-12 h-12 bg-navy text-white rounded-full flex items-center justify-center mx-auto mb-4 text-lg font-bold shadow-lg group-hover:bg-gold transition-colors" data-id="element-368">
                {index + 1}
              </div>
              <h4 className="text-lg font-bold text-navy mb-2" data-id="element-369">{step.title}</h4>
              <p className="text-sm text-gray-500" data-id="element-370">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}